import { Component } from '@angular/core';
import { AppStateProvider } from 'src/app/_Core/_Providers/app-state.provider';

@Component({
  standalone: false,
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.scss'],
  selector: 'forbidden'
})
export class ForbiddenComponent {
  meetingNav: { index: string; name: string; link: string; }[];
  constructor(private appStateSrv: AppStateProvider) {
    this.appStateSrv.setLoginStatus(true);
  }

  ngOnInit(): void {

  }
}
